import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
        <p className="text-2xl text-gray-500 mb-2">Construída con 🩵 por Tigemsha</p>
        <p className="text-2xl text-gray-500">© Todos los derechos reservados</p>
    </footer>
  )
}

export default Footer